import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, switchMap, take } from 'rxjs';
import { AuthenticationState } from "../store/auth/auth.state";

@Injectable()
export class ApiKeyInterceptor implements HttpInterceptor {
  constructor(private authState: AuthenticationState) {
  }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    // Don't add auth header to the anonymous auth endpoints (login has no token yet)
    if (request.url.includes('/api/auth/login')) {
      return next.handle(request);
    }

    const token = this.authState.snapshot.token;
    if (!token) {
      return next.handle(request);
    }

    return next.handle(request.clone({
      setHeaders: { Authorization: `Bearer ${token}` }
    }));
  }
}
